import { lazy } from 'react'

//search
const DrivingTestConfigurationList = lazy(() => import('../../views/driving-test/test-configuration/list'))
const AddNewTestDate = lazy(() => import('../../views/driving-test/test-configuration/add'))
const TestConfigurationView = lazy(() => import('../../views/driving-test/test-configuration/view'))
const DrivingETestCandidateList = lazy(() => import('../../views/driving-test/e-test-candidate/list'))
const DrivingTestCandidateList = lazy(() => import('../../views/driving-test/test-candidate/list'))
const DrivingTestQuestionList = lazy(() => import('../../views/driving-test/question/list'))
const TestQuestionView = lazy(() => import('../../views/driving-test/question/view'))
const AddTestMarksheet = lazy(() => import('../../views/driving-test/test-marksheet/add'))
const DrivingTestSectionList = lazy(() => import('../../views/driving-test/section/list'))
const ETestSectionView = lazy(() => import('../../views/driving-test/section/view'))
const TheoryRecheck = lazy(() => import('../../views/driving-test/theory-recheck'))
const LearnerTheorySessions = lazy(() => import('../../views/driving-test/learner-theory/sessions'))
const LearnerTheorySession = lazy(() => import('../../views/driving-test/learner-theory/session'))
const LearnerTheoryResults = lazy(() => import('../../views/driving-test/learner-theory/results'))

const DrivingTestRoutes = [
  {
    path: '/driving-test/learner-theory',
    element: <LearnerTheorySessions />,
    meta: { action: 'read', resource: 'ETestManagement' }
  },
  {
    path: '/driving-test/learner-theory/results',
    element: <LearnerTheoryResults />,
    meta: { action: 'read', resource: 'ETestManagement' }
  },
  {
    path: '/driving-test/learner-theory/:id',
    element: <LearnerTheorySession />,
    meta: { action: 'read', resource: 'ETestManagement' }
  },
  {
    path: '/driving-test/etest-sections',
    element: <DrivingTestSectionList />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/etest-sections/view/:id',
    element: <ETestSectionView />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  // test configuration
  {
    path: '/driving-test/test-configurations',
    element: <DrivingTestConfigurationList />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-configurations/view/:id',
    element: <TestConfigurationView />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-configurations/view/:id/e-test-candidates',
    element: <DrivingETestCandidateList />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-configurations/view/:id/test-candidates',
    element: <TestConfigurationView />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-candidates',
    element: <DrivingTestCandidateList />,
    meta: {
      action: 'manage',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-configurations/new',
    element: <AddNewTestDate />,
    meta: {
      action: 'manage',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-questions',
    element: <DrivingTestQuestionList />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-questions/view/:id',
    element: <TestQuestionView />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  },
  {
    path: '/driving-test/test-marksheet/add',
    element: <AddTestMarksheet />,
    meta: {
      action: 'manage',
      resource: 'Marksheet'
    }
  },
  {
    path: '/driving-test/theory-recheck',
    element: <TheoryRecheck />,
    meta: {
      action: 'read',
      resource: 'ETestManagement'
    }
  }
]

export default DrivingTestRoutes
